import { api } from '@/_api'
import { userService } from '@/_services'

export const users = {
  namespaced: true,
  state: {
    value: {
      id: 0
    },
    list: [],
    spicker: 0,
    uploadedUsers: [],
  },
  mutations: {
    set(state, value) {
      state.value = value
    },
    add(state, list) {
      state.list = state.list.concat(list)
    },
    remove(state, id) {
      let user = state.list.find(u => u.id == id)
      user.status = 'REMOVE'
    },
    setSpicker(state, spicker) {
      state.spicker = spicker
    },

    setUploadedUsers(state, users) {
      state.uploadedUsers = users
    },
  },
  actions: {
    add({ commit }, channel_id) {
      if (!channel_id) return
      let i = 0;
      api.series.users(channel_id)
        .then(data => commit('add', data.map(u => {
          u['channel'] = channel_id
          u['position'] = i++;
          return u;
        })))
    },

    async setSpicker({ commit }, spicker) {
      commit('setSpicker', spicker)
    },

    async remove({ commit }, id) {
      api.user.remove(id).then(() => {
        commit('remove', id)
      })
    },

  },
  getters: {
    // methods for admin
    users: state => {
      if (state.list.length == 0)
        userService.list().then(data => {
          state.list = data
        });
      return state.list;
    },

    // methods for spickers
    getUsers: state => id => {
      let val = state.list.filter(u => u.channel == id);
      val.sort((a1, a2) => {
        if (a2.position < a1.position) return 1;
        else if (a2.position > a1.position) return -1;
        return 0;
      })
      return val
    },

    spicker: state => {
      return state.list.find(u => u.id == state.spicker);
    },
  }
}